import React from "react";
import { Outlet } from "react-router-dom";

import { styled } from "styled-components";


import UserSidebar from "../Sidebars/userSidebar";
import ListenerNav from "../ListenerPages/ListenerNav";
import ListenerSidebar from "../Sidebars/listenerSidebar";

export default function ListenerDashboardLayout() {
//   const {openSideBar} = useSelector((state)=> state.app)
  return (
    <Wrapper>
      <div className="nav">
     <ListenerNav />
     </div>
      <div
        style={{}}
        className="outlet"
      >
         {/* <ListenerSidebar/> */}
       
        <div className="div">
          <Outlet />
        </div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  .nav {
    background: #060B130A;

    z-index: 9999;
  }
  .outlet {
    width: 100%;
    background: #060B130A;

    margin-top: 74px;
    /* z-index: -1; */
    display: flex;
    flex-direction: row;
  }
  .div{
    width: 100% !important;
    /* margin-top: 45px !important; */
   
  }
  @media screen and (max-width: 1120px) {
    .div{
   width: 100% !important;
   padding-top: 18px;
   padding-left: 10px;
 }
  }

  @media screen and (max-width: 992px) {
.div {
  padding-top: 60px;

}
  }
  @media screen and (max-width: 1100px) {

    .outlet {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 630px) {
.div {
  padding-top: 110px;

}
  }
  @media screen and (max-width: 475px) {
.div {
  padding-top: 135px;

}
  }
  @media screen and (max-width: 435px) {
.div {
  padding-top: 195px;

}
  }
  @media screen and (max-width: 340px) {
.div {
  padding-top: 218px;

}
  }
`;
